import invariant from 'utils/invariant';

import useFeatureFlags from 'hooks/useFeatureFlags';

const typeToFeatureMap = {
  multiple_choice: 'linked_elements_question_multiple_choice',
};

// Elements that have been rolled into the base linked_elements feature flag
const baseLinkedElementTypes = {
  paragraph: true,
};

const hasTypeFeature = type => !!typeToFeatureMap[type];

/**
 * Checks whether the linked element feature flag is enabled the specified
 * element type.
 *
 * @param {Object<string, boolean>} features
 * @param {string} type
 * @param {string=} contentType
 * @return {boolean}
 */
export function useIsFeatureEnabledForLinkedElement(type, contentType) {
  if (process.env.NODE_ENV === 'development') {
    invariant(
      typeof type === 'string',
      `Expect type argument to be of type string, but instead received ${typeof type}`,
    );
  }

  if (type === 'question') {
    type = contentType;
  }

  const hasTypeFeatureEnabled = useFeatureFlags(typeToFeatureMap[type]);

  // Certain element types have been rolled into base Linked Elements functionality.
  // More element types can be added to baseLinkedElementTypes once they're ready!
  if (baseLinkedElementTypes[type]) {
    return true;
  }

  return hasTypeFeature(type) && hasTypeFeatureEnabled;
}
